import firebaseConfig from '../../public/json/firebase-config.development.json';

export const environment = {
    apiGatewayUrl: 'https://dev.timaisearch.timenterprise.it/gateway',
    searchUrl: 'https://dev.timaisearch.timenterprise.it',
    fcmVapid: 'BFu969btXwK6Tj2l0r4ogoKdR3tWZlg1PkygYOpj577f6D17wEximslCEcwDALGEz-90au7t7zPHdlUK5rQSEa4',
    reCaptchaSiteKey: '6Lc_n_ArAAAAACtoRervNv0TypeKiUTrVYz0ETyx',
    demoMode: false,
    firebase: firebaseConfig
};
